import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Edit from './Edit';
import Delete from './Delete';

const ViewList = ({ data, index }) => {
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && 'bg-gray-100'}`}>
        <TD>{index + 1}</TD>
        <TD>{data.reason}</TD>
        <TD>
          {data.createdAt ? new Date(data.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-') : ''}
        </TD>
        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => setShowDeleteModel(true)}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showEditModel && (
        <Edit data={data} handleClick={() => setShowEditModel(false)} />
      )}
      {showDeleteModel && (
        <Delete data={data} handleClick={() => setShowDeleteModel(false)} />
      )}
    </Fragment>
  );
};

export default ViewList;
